import { SettingsRoutes } from 'pages/settings/route/type'
import { AddOnsRoutes } from './type'

const root = `${SettingsRoutes.root}/${SettingsRoutes.organization}/${AddOnsRoutes.root}`

export const AddOnsPath = {
  root: root,
}
